<template>
  <div v-if="pageCount > 1">
    <paginate
      :click-handler="setActivePage"
      :page-count="pageCount"
      prev-text="«"
      next-text="»"
      container-class="pagination"
      ref="paginate">
    </paginate>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SET_SKIP } from '@/store/actionTypes'

export default {
  name: 'SearchPagination',

  computed: {
    ...mapState({
      results: state => state.results,
      skip: state => state.skip
    }),

    pageCount() {
      return Math.ceil(this.results.total / 10)
    }
  },

  watch: {
    skip: {
      handler: function() {
        this.setSelectedPage()// Skip returns 10 per page, so it has to be divided by 10 to get the correct page
      }
    }
  },

  methods: {
    setActivePage(page) {
      this.$store.commit(SET_SKIP, page)
    }, 
    setSelectedPage() {
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = this.skip / 10
      }
    }
  },

  mounted() {
    // When returning to this component this makes sure the selected page is correct
    this.setSelectedPage()
  }
}
</script>

<style lang="postcss">
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 21px 0;
  border-radius: 4px;
}

.pagination > li {
  display: inline;
}

.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 10px 20px;
  line-height: 1.428571429;
  text-decoration: none;
  color: #06769f;
  background-color: #fff;
  border: 1px solid #ddd;
  margin-left: -1px;
}

.pagination > li:first-child > a,
.pagination > li:first-child > span {
  margin-left: 0;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.pagination a,
.pagination span {
  display: block;
  float: left;
  padding: 0.3em 0.5em;
  margin-right: 5px;
  margin-bottom: 5px;
  min-width: 1em;
  text-align: center;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: default;
}

.pagination > .disabled > a,
.pagination > .disabled > a:focus,
.pagination > .disabled > a:hover,
.pagination > .disabled > span,
.pagination > .disabled > span:focus,
.pagination > .disabled > span:hover {
  color: #777;
  background-color: #fff;
  border-color: #ddd;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchPagination.vue